// import { useState, useRef, useEffect } from "react";

// /**
//  * WeekDaySlider
//  * Props:
//  *   selectedDate  – Date object (controlled)
//  *   onDateChange  – (Date) => void
//  *   weekOffset    – number (controlled, 0 = current week)
//  *   onWeekChange  – (number) => void
//  *
//  * All props are optional; the component works standalone too.
//  */
// export default function WeekDaySlider({
//   selectedDate: selectedDateProp,
//   onDateChange,
//   weekOffset: weekOffsetProp,
//   onWeekChange,
// }) {
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const [internalOffset, setInternalOffset] = useState(0);
//   const [internalSelected, setInternalSelected] = useState(new Date(today));

//   const weekOffset = weekOffsetProp !== undefined ? weekOffsetProp : internalOffset;
//   const selectedDate = selectedDateProp !== undefined ? selectedDateProp : internalSelected;

//   const setWeekOffset = (val) => {
//     if (onWeekChange) onWeekChange(val);
//     else setInternalOffset(val);
//   };
//   const setSelectedDate = (val) => {
//     if (onDateChange) onDateChange(val);
//     else setInternalSelected(val);
//   };

//   // Build the 7 days of the visible week (Mon–Sun)
//   const getWeekDays = (offset) => {
//     const now = new Date(today);
//     const dayOfWeek = now.getDay(); // 0=Sun
//     const mondayDiff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
//     const monday = new Date(now);
//     monday.setDate(now.getDate() + mondayDiff + offset * 7);

//     return Array.from({ length: 7 }, (_, i) => {
//       const d = new Date(monday);
//       d.setDate(monday.getDate() + i);
//       return d;
//     });
//   };

//   const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
//   const days = getWeekDays(weekOffset);

//   const isToday = (d) => d.toDateString() === today.toDateString();
//   const isSelected = (d) => d.toDateString() === selectedDate.toDateString();
//   const isSat = (d) => d.getDay() === 6;
//   const isSun = (d) => d.getDay() === 0;

//   // Format header month/year for the date filter display
//   const startMonth = days[0].toLocaleString("en-GB", { month: "short", year: "numeric" });
//   const endMonth = days[6].toLocaleString("en-GB", { month: "short", year: "numeric" });
//   const headerLabel = startMonth === endMonth ? startMonth : `${days[0].toLocaleString("en-GB", { month: "short" })} – ${endMonth}`;

//   return (
//     <div style={styles.wrapper}>
//       {/* Date filter row */}
//       <div style={styles.filterRow}>
//         <div style={styles.dateDisplay}>
//           <span style={styles.dateText}>{headerLabel}</span>
//           <svg width="14" height="14" fill="none" stroke="#666" strokeWidth="2" viewBox="0 0 24 24">
//             <path d="M6 9l6 6 6-6" />
//           </svg>
//         </div>

//         <div style={styles.navGroup}>
//           <button
//             onClick={() => setWeekOffset(weekOffset - 1)}
//             style={styles.navBtn}
//             aria-label="Previous week"
//           >
//             <svg width="13" height="13" fill="none" stroke="#555" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
//               <path d="M15 18l-6-6 6-6" />
//             </svg>
//           </button>
//           <button
//             onClick={() => setWeekOffset(weekOffset + 1)}
//             style={styles.navBtn}
//             aria-label="Next week"
//           >
//             <svg width="13" height="13" fill="none" stroke="#555" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
//               <path d="M9 18l6-6-6-6" />
//             </svg>
//           </button>
//         </div>
//       </div>

//       {/* Day cells row */}
//       <div style={styles.daysRow}>
//         {days.map((d, i) => {
//           const todayDay = isToday(d);
//           const selectedDay = isSelected(d);
//           const weekend = isSat(d) || isSun(d);

//           return (
//             <button
//               key={i}
//               onClick={() => setSelectedDate(new Date(d))}
//               style={{
//                 ...styles.dayCell,
//                 ...(todayDay ? styles.todayCell : {}),
//                 ...(selectedDay && !todayDay ? styles.selectedCell : {}),
//               }}
//               aria-label={`${DAY_LABELS[i]} ${d.getDate()}`}
//             >
//               <span
//                 style={{
//                   ...styles.dayLabel,
//                   color: todayDay
//                     ? "#fff"
//                     : weekend
//                     ? "#e05c9a"
//                     : "#999",
//                 }}
//               >
//                 {DAY_LABELS[i]}
//               </span>
//               <span
//                 style={{
//                   ...styles.dayNumber,
//                   color: todayDay
//                     ? "#fff"
//                     : selectedDay
//                     ? "#7c3ab5"
//                     : weekend
//                     ? "#e05c9a"
//                     : "#333",
//                   fontWeight: todayDay || selectedDay ? 700 : 500,
//                 }}
//               >
//                 {String(d.getDate()).padStart(2, "0")}
//               </span>

//               {/* selected ring (non-today) */}
//               {selectedDay && !todayDay && (
//                 <span style={styles.selectedRing} />
//               )}
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// /* ─── Styles ─────────────────────────────────────────── */
// const styles = {
//   wrapper: {
//     background: "#fff",
//     padding: "10px 14px 14px",
//     fontFamily: "'Segoe UI', sans-serif",
//   },

//   /* filter row */
//   filterRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: 14,
//   },
//   dateDisplay: {
//     display: "flex",
//     alignItems: "center",
//     gap: 5,
//     border: "1.5px solid #ddd",
//     borderRadius: 7,
//     padding: "5px 10px",
//     cursor: "pointer",
//     background: "#fafafa",
//   },
//   dateText: {
//     fontSize: 12.5,
//     color: "#555",
//     fontWeight: 500,
//   },

//   /* nav buttons */
//   navGroup: {
//     display: "flex",
//     gap: 6,
//   },
//   navBtn: {
//     width: 30,
//     height: 30,
//     border: "1.5px solid #ddd",
//     borderRadius: 7,
//     background: "#fff",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     transition: "background 0.15s, border-color 0.15s",
//   },

//   /* days row */
//   daysRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     gap: 2,
//   },

//   /* each day cell */
//   dayCell: {
//     flex: 1,
//     position: "relative",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: 5,
//     padding: "7px 2px",
//     border: "none",
//     background: "transparent",
//     cursor: "pointer",
//     borderRadius: 50,
//     transition: "background 0.15s",
//     outline: "none",
//   },

//   /* today: solid purple pill */
//   todayCell: {
//     background: "linear-gradient(160deg, #9b2db5 0%, #5b2a8a 100%)",
//     borderRadius: 50,
//     boxShadow: "0 3px 10px rgba(100,40,160,0.30)",
//   },

//   /* selected (non-today): ring outline */
//   selectedCell: {
//     background: "transparent",
//   },
//   selectedRing: {
//     position: "absolute",
//     inset: 0,
//     borderRadius: 50,
//     border: "2px solid #7c3ab5",
//     pointerEvents: "none",
//   },

//   dayLabel: {
//     fontSize: 11,
//     fontWeight: 600,
//     letterSpacing: 0.2,
//     textTransform: "capitalize",
//   },
//   dayNumber: {
//     fontSize: 14,
//   },
// };


import { useState, useEffect, useRef } from "react";

/* ── Mock Data ─────────────────────────────────────── */
const ALL_TASKS = [
  {
    id: 1,
    title: "Microchip",
    status: "Completed",
    leadId: "51203",
    noOfPet: "02",
    petType: "Dog & Cat",
    customerName: "RDX",
    contact: "+91 **********",
    address: "2nd Floor, Plot No. 269, Phase IV, Udyog Vihar, Sector 18, Gurugram, Haryana 122015",
    date: new Date(),
  },
  {
    id: 2,
    title: "Dog Pick-Up (NOC)",
    status: "Pending",
    leadId: "54563",
    noOfPet: "01",
    petType: "Dog",
    customerName: "Rahul Sharma",
    contact: "+91 **********",
    address: "Sector 45, Gurugram, Haryana 122003",
    date: new Date(),
  },
  {
    id: 3,
    title: "Vaccination",
    status: "Cancelled",
    leadId: "48901",
    noOfPet: "03",
    petType: "Cat",
    customerName: "Priya Singh",
    contact: "+91 **********",
    address: "DLF Phase 2, Gurugram, Haryana 122002",
    date: new Date(Date.now() - 86400000),
  },
  {
    id: 4,
    title: "Grooming",
    status: "Completed",
    leadId: "47650",
    noOfPet: "01",
    petType: "Dog",
    customerName: "Amit Kumar",
    contact: "+91 **********",
    address: "Sohna Road, Gurugram, Haryana 122018",
    date: new Date(Date.now() - 86400000),
  },
  {
    id: 5,
    title: "Health Checkup",
    status: "Pending",
    leadId: "46100",
    noOfPet: "02",
    petType: "Dog & Cat",
    customerName: "Neha Verma",
    contact: "+91 **********",
    address: "Palam Vihar, Gurugram, Haryana 122017",
    date: new Date(Date.now() + 86400000 * 2),
  },
];

const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const TABS = ["All", "Completed", "Pending", "Cancelled"];

const STATUS_STYLE = {
  Completed: { bg: "#22c55e", color: "#fff" },
  Pending:   { bg: "#9ca3af", color: "#fff" },
  Cancelled: { bg: "#ef4444", color: "#fff" },
};

/* ── Helpers ───────────────────────────────────────── */
function getWeekDays(offset) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dow = today.getDay();
  const mondayDiff = dow === 0 ? -6 : 1 - dow;
  const monday = new Date(today);
  monday.setDate(today.getDate() + mondayDiff + offset * 7);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d;
  });
}

function pad(n) { return String(n).padStart(2, "0"); }
function sameDay(a, b) { return a.toDateString() === b.toDateString(); }

/* ── Stopwatch ─────────────────────────────────────── */
function Stopwatch() {
  const [secs, setSecs] = useState(0);
  const [running, setRunning] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (running) ref.current = setInterval(() => setSecs(s => s + 1), 1000);
    else clearInterval(ref.current);
    return () => clearInterval(ref.current);
  }, [running]);

  const hh = pad(Math.floor(secs / 3600));
  const mm = pad(Math.floor((secs % 3600) / 60));
  const ss = pad(secs % 60);

  return (
    <div style={sw.wrapper} onClick={() => setRunning(r => !r)}>
      {/* watermark icon */}
      <div style={sw.watermark}>
        <svg width="72" height="72" fill="none" viewBox="0 0 24 24" stroke="rgba(255,255,255,0.12)" strokeWidth="1.2">
          <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/>
        </svg>
      </div>

      <div style={sw.timeRow}>
        <span style={sw.time}>{hh} : {mm} : {ss}</span>
        <button style={sw.iconBtn} onClick={e => { e.stopPropagation(); setSecs(0); setRunning(false); }}>
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="1.8">
            <circle cx="12" cy="12" r="7"/><path d="M8 12l4-4 4 4"/>
            <rect x="3" y="3" width="4" height="4" rx="1" fill="#fff" stroke="none"/>
          </svg>
        </button>
      </div>

      <div style={sw.labelRow}>
        <span style={sw.label}>Pet Taxi</span>
        <svg width="28" height="12" fill="none" viewBox="0 0 28 12">
          <line x1="0" y1="6" x2="22" y2="6" stroke="#fff" strokeWidth="1.5"/>
          <path d="M18 2l6 4-6 4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
}

/* ── Task Card ─────────────────────────────────────── */
function TaskCard({ task }) {
  const [open, setOpen] = useState(false);
  const st = STATUS_STYLE[task.status] || STATUS_STYLE.Pending;

  return (
    <div style={card.wrapper} onClick={() => setOpen(o => !o)}>
      <div style={card.header}>
        <span style={card.title}>{task.title}</span>
        <span style={{ ...card.badge, background: st.bg, color: st.color }}>{task.status}</span>
      </div>
      <div style={card.row}><span style={card.key}>Lead Id</span><span style={card.sep}>:</span><span style={card.val}>{task.leadId}</span></div>
      {open && (
        <>
          <div style={card.row}><span style={card.key}>No. of Pet</span><span style={card.sep}>:</span><span style={card.val}>{task.noOfPet}</span></div>
          <div style={card.row}><span style={card.key}>Pet Type</span><span style={card.sep}>:</span><span style={card.val}>{task.petType}</span></div>
          <div style={card.row}><span style={card.key}>Customer Name</span><span style={card.sep}>:</span><span style={card.val}>{task.customerName}</span></div>
          <div style={card.row}><span style={card.key}>Contact No.</span><span style={card.sep}>:</span><span style={card.val}>{task.contact}</span></div>
          <div style={{ ...card.row, alignItems: "flex-start" }}>
            <span style={card.key}>Address</span>
            <span style={card.sep}>:</span>
            <span style={{ ...card.val, lineHeight: 1.5 }}>{task.address}</span>
          </div>
        </>
      )}
    </div>
  );
}

/* ── Main Component ────────────────────────────────── */
export default function TaskDashboard() {
  const todayRef = new Date();
  todayRef.setHours(0, 0, 0, 0);

  const [weekOffset, setWeekOffset] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date(todayRef));
  const [activeTab, setActiveTab] = useState("All");

  const days = getWeekDays(weekOffset);

  const headerLabel = (() => {
    const s = days[0].toLocaleString("en-GB", { month: "short", year: "numeric" });
    const e = days[6].toLocaleString("en-GB", { month: "short", year: "numeric" });
    return s === e ? s : `${days[0].toLocaleString("en-GB", { month: "short" })} – ${e}`;
  })();

  const todayTasks = ALL_TASKS.filter(t => sameDay(t.date, todayRef));
  const upcomingTasks = ALL_TASKS.filter(t => t.date > todayRef);

  const filteredTasks = ALL_TASKS.filter(t => {
    const dayMatch = sameDay(t.date, selectedDate);
    const tabMatch = activeTab === "All" || t.status === activeTab;
    return dayMatch && tabMatch;
  });

  return (
    <div style={layout.page}>
      <div style={layout.phone}>

        {/* ── Stat Cards ── */}
        <div style={layout.statRow}>
          <div style={{ ...layout.statCard, background: "linear-gradient(135deg,#d63384 0%,#9b2db5 100%)" }}>
            <div style={layout.statIcon}>
              <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="rgba(255,255,255,0.85)" strokeWidth="1.6">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
                <rect x="9" y="3" width="6" height="4" rx="1"/>
                <path d="M9 12h6M9 16h4"/>
              </svg>
            </div>
            <span style={layout.statLabel}>Today's Tasks</span>
            <span style={layout.statNum}>{pad(todayTasks.length)}</span>
            <div style={layout.statWatermark}>
              <svg width="60" height="60" fill="none" viewBox="0 0 24 24" stroke="rgba(255,255,255,0.1)" strokeWidth="1">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
                <rect x="9" y="3" width="6" height="4" rx="1"/>
              </svg>
            </div>
          </div>

          <div style={{ ...layout.statCard, background: "linear-gradient(135deg,#7c3ab5 0%,#4a1a80 100%)" }}>
            <div style={layout.statIcon}>
              <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="rgba(255,255,255,0.85)" strokeWidth="1.6">
                <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/>
              </svg>
            </div>
            <span style={layout.statLabel}>Total Upcoming Task</span>
            <span style={layout.statNum}>{pad(upcomingTasks.length)}</span>
            <div style={layout.statWatermark}>
              <svg width="60" height="60" fill="none" viewBox="0 0 24 24" stroke="rgba(255,255,255,0.1)" strokeWidth="1">
                <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/>
              </svg>
            </div>
          </div>
        </div>

        {/* ── Stopwatch ── */}
        <div style={{ padding: "0 14px 14px" }}>
          <Stopwatch />
        </div>

        {/* ── Tasks List Header ── */}
        <div style={{ padding: "0 14px 10px" }}>
          <div style={tl.header}>
            <span style={tl.headerText}>Tasks List</span>
          </div>
        </div>

        {/* ── Week Slider ── */}
        <div style={{ padding: "0 14px 4px" }}>
          {/* filter row */}
          <div style={ws.filterRow}>
            <div style={ws.dateBox}>
              <span style={ws.dateText}>{headerLabel}</span>
              <svg width="13" height="13" fill="none" stroke="#888" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div style={ws.navGroup}>
              <button style={ws.navBtn} onClick={() => setWeekOffset(w => w - 1)}>
                <svg width="13" height="13" fill="none" stroke="#555" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <button style={ws.navBtn} onClick={() => setWeekOffset(w => w + 1)}>
                <svg width="13" height="13" fill="none" stroke="#555" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>
          </div>

          {/* day cells */}
          <div style={ws.daysRow}>
            {days.map((d, i) => {
              const isToday = sameDay(d, todayRef);
              const isSel = sameDay(d, selectedDate);
              const isWeekend = d.getDay() === 0 || d.getDay() === 6;
              return (
                <button
                  key={i}
                  onClick={() => setSelectedDate(new Date(d))}
                  style={{
                    ...ws.dayCell,
                    background: isToday
                      ? "linear-gradient(160deg,#9b2db5 0%,#5b2a8a 100%)"
                      : "transparent",
                    boxShadow: isToday ? "0 3px 10px rgba(100,40,160,0.30)" : "none",
                    outline: isSel && !isToday ? "2px solid #7c3ab5" : "none",
                    outlineOffset: -2,
                  }}
                >
                  <span style={{
                    fontSize: 10.5, fontWeight: 600, letterSpacing: 0.2,
                    color: isToday ? "#fff" : isWeekend ? "#e05c9a" : "#999",
                  }}>{DAY_LABELS[i]}</span>
                  <span style={{
                    fontSize: 13.5, fontWeight: isToday || isSel ? 700 : 500,
                    color: isToday ? "#fff" : isWeekend ? "#e05c9a" : "#333",
                  }}>{pad(d.getDate())}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* ── Status Tabs ── */}
        <div style={tabs.row}>
          {TABS.map(t => (
            <button key={t} onClick={() => setActiveTab(t)} style={{
              ...tabs.btn,
              color: activeTab === t ? "#7c3ab5" : "#888",
              borderBottom: activeTab === t ? "2.5px solid #7c3ab5" : "2.5px solid transparent",
              fontWeight: activeTab === t ? 700 : 500,
            }}>{t}</button>
          ))}
        </div>

        {/* ── Task Cards ── */}
        <div style={{ padding: "10px 14px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
          {filteredTasks.length === 0 ? (
            <div style={{ textAlign: "center", color: "#bbb", padding: "30px 0", fontSize: 14 }}>
              No tasks found
            </div>
          ) : (
            filteredTasks.map(t => <TaskCard key={t.id} task={t} />)
          )}
        </div>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   Styles
══════════════════════════════════════════════════════ */

const layout = {
  page: {
    minHeight: "100vh",
    background: "#f0eef8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "24px 0",
    fontFamily: "'Segoe UI', sans-serif",
  },
  phone: {
    width: 400,
    background: "#f4f4f8",
    borderRadius: 20,
    overflow: "hidden",
    boxShadow: "0 12px 40px rgba(80,30,140,0.15)",
    paddingTop: 14,
  },
  statRow: {
    display: "flex",
    gap: 12,
    padding: "0 14px 14px",
  },
  statCard: {
    flex: 1,
    borderRadius: 14,
    padding: "14px 14px 16px",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
  },
  statIcon: {
    width: 40, height: 40,
    borderRadius: 10,
    background: "rgba(255,255,255,0.18)",
    display: "flex", alignItems: "center", justifyContent: "center",
    marginBottom: 8,
  },
  statLabel: {
    display: "block",
    fontSize: 12, color: "rgba(255,255,255,0.85)", fontWeight: 500,
    marginBottom: 4,
  },
  statNum: {
    display: "block",
    fontSize: 28, color: "#fff", fontWeight: 800, letterSpacing: 1,
  },
  statWatermark: {
    position: "absolute", right: 6, bottom: 4, opacity: 1,
  },
};

const sw = {
  wrapper: {
    background: "linear-gradient(135deg,#7c3ab5 0%,#4a1a80 100%)",
    borderRadius: 14,
    padding: "14px 16px 14px",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    userSelect: "none",
  },
  watermark: {
    position: "absolute", right: 8, top: 8, opacity: 1,
  },
  timeRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  time: {
    fontSize: 28, fontWeight: 700, color: "#fff",
    letterSpacing: 3, fontVariantNumeric: "tabular-nums",
  },
  iconBtn: {
    background: "rgba(255,255,255,0.18)",
    border: "none", borderRadius: 10,
    width: 36, height: 36,
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer",
  },
  labelRow: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
  },
  label: { fontSize: 14, color: "rgba(255,255,255,0.85)", fontWeight: 500 },
};

const tl = {
  header: {
    background: "#7c3ab5",
    borderRadius: 10,
    padding: "11px 16px",
  },
  headerText: {
    color: "#fff", fontWeight: 700, fontSize: 16,
  },
};

const ws = {
  filterRow: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", marginBottom: 12,
  },
  dateBox: {
    display: "flex", alignItems: "center", gap: 5,
    border: "1.5px solid #ddd", borderRadius: 7,
    padding: "5px 10px", background: "#fafafa", cursor: "pointer",
  },
  dateText: { fontSize: 12.5, color: "#555", fontWeight: 500 },
  navGroup: { display: "flex", gap: 6 },
  navBtn: {
    width: 30, height: 30,
    border: "1.5px solid #ddd", borderRadius: 7,
    background: "#fff", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  daysRow: {
    display: "flex", justifyContent: "space-between", gap: 2,
    background: "#fff", borderRadius: 12,
    padding: "8px 6px",
    boxShadow: "0 2px 8px rgba(100,40,160,0.07)",
  },
  dayCell: {
    flex: 1,
    display: "flex", flexDirection: "column",
    alignItems: "center", gap: 5,
    padding: "7px 2px",
    border: "none",
    borderRadius: 50,
    cursor: "pointer",
    transition: "all 0.15s",
    outline: "none",
  },
};

const tabs = {
  row: {
    display: "flex",
    background: "#fff",
    borderBottom: "1.5px solid #ede8f8",
    padding: "0 14px",
    marginTop: 8,
  },
  btn: {
    flex: 1,
    background: "none",
    border: "none",
    padding: "10px 0",
    fontSize: 13,
    cursor: "pointer",
    transition: "all 0.15s",
    letterSpacing: 0.2,
  },
};

const card = {
  wrapper: {
    background: "#fff",
    border: "1.5px solid #ede8f8",
    borderRadius: 12,
    padding: "12px 14px",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(100,40,160,0.06)",
    transition: "box-shadow 0.2s",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  title: { fontWeight: 700, color: "#7c3ab5", fontSize: 15 },
  badge: {
    fontSize: 11.5, fontWeight: 600,
    padding: "3px 10px", borderRadius: 20,
  },
  row: {
    display: "flex",
    gap: 6,
    marginBottom: 5,
    fontSize: 13,
    color: "#444",
  },
  key: { width: 115, color: "#999", flexShrink: 0 },
  sep: { color: "#bbb", flexShrink: 0 },
  val: { flex: 1 },
};
